import { useDispatch } from 'react-redux';
import BinaryQuestion from '~/components/binary-question';
import useTranslations from '~/components/translation/use-translations.ts';
import { showSupportDialogBox } from '~/components/support/ducks/index.js';

const TEXT_KEYS = [
	'PRODUCT_DISABLED_POPUP_TITLE',
	'PRODUCT_DISABLED_POPUP_DESCRIPTION',
	'BUTTON_CUSTOMER_SUPPORT',
	'BUTTON_CANCEL'
];
const ProductDisabledPopup = ({ onClose }) => {
	const { translations, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const dispatch = useDispatch();

	return (
		!isLoadingTranslations && (
			<BinaryQuestion
				shouldOpenBinary
				title={translations.PRODUCT_DISABLED_POPUP_TITLE}
				text={translations.PRODUCT_DISABLED_POPUP_DESCRIPTION}
				yesText={translations.BUTTON_CUSTOMER_SUPPORT}
				onYesClick={() => {
					dispatch(showSupportDialogBox(true));
					onClose();
				}}
				noText={translations.BUTTON_CANCEL}
				onNoClick={() => {
					onClose();
				}}
			/>
		)
	);
};

export default ProductDisabledPopup;
